import { InferType, object, string } from 'yup';

export const SubdomainRegistrationInDtoSchema = object({
  subdomain: string().matches(
    /^([a-z0-9-]{2,20})?$/,
    'Invalid format: must be 2-20 characters long and contain only lowercase letters, numbers, and hyphens.'
  ),
});
export type SubdomainRegistrationInDtoSchema = InferType<typeof SubdomainRegistrationInDtoSchema>;
